export default function(gumStream){
    try{
        gumStream.getTracks().forEach(function(track) {
            track.stop();
        });
    }catch(e){
        console.log('Error releasing media.')
        // console.log(e)
    }
}